import { useEffect, useState } from 'react'
import { onAuthStateChanged } from 'firebase/auth'
import { auth } from '../libs/Firebase'
import { UserRole } from '../../../pure-js/types/User'

/**
 * True when the Firebase user on this origin has the SuperAdmin custom claim.
 * Note: admin.coursely.se sessions are not shared with app.coursely.se — the user must
 * be signed into Firebase on the user-web origin for this to return true in production.
 */
export const useIsSuperAdmin = (): boolean => {
  const [isSuperAdmin, setIsSuperAdmin] = useState(false)

  useEffect(() => {
    return onAuthStateChanged(auth, async (firebaseUser) => {
      if (!firebaseUser) {
        setIsSuperAdmin(false)
        return
      }
      try {
        const token = await firebaseUser.getIdTokenResult()
        const roles = token.claims.roles
        const roleList = Array.isArray(roles) ? roles : []
        setIsSuperAdmin(roleList.includes(UserRole.SuperAdmin))
      } catch (err) {
        console.error('[useIsSuperAdmin] failed to read claims', err)
        setIsSuperAdmin(false)
      }
    })
  }, [])

  return isSuperAdmin
}
